export const CLOCK_TYPE_BY_TIME_KEY = {
  startTime: 'in',
  endTime: 'out',
  checkInTime: 'checkIn',
  checkOutTime: 'checkOut'
};

export const withOptimisticAdminReportMethod = (reportMethods, timeKey) => {
  const clockType = CLOCK_TYPE_BY_TIME_KEY[timeKey];

  if (!clockType) {
    return reportMethods;
  }

  return [
    ...(reportMethods || []).filter((method) => method?.clockType !== clockType),
    { clockType, reportMethod: 'admin', metadata: { source: 'timesheet_tab' } }
  ];
};

export const keyReportMethodsByClockType = (reportMethods) =>
  (reportMethods || []).reduce((output, method) => {
    if (method?.clockType) {
      output[method.clockType] = method;
    }
    return output;
  }, {});

/**
 * Whether the preserved reported time was entered by an admin rather than punched by the employee.
 *
 * Takes the `reported*` method - the owner of the reported value itself - not the method of the
 * clock. Those diverge the moment an admin edits a cell the employee reported: the clock becomes
 * admin-written while the reported time stays the employee's.
 */
export const isAdminEnteredReport = (reportedValueMethod) => reportedValueMethod?.reportMethod === 'admin';

export const getReportMethodSourceKey = (method) => {
  const slug = method?.reportMethod;

  if (!slug) {
    return null;
  }

  if (slug !== 'admin') {
    return slug;
  }

  const source = method?.metadata?.source;
  const normalizedSource = source === 'os' ? 'timesheet_tab' : source;

  return `admin:${normalizedSource || 'unknown'}`;
};

export const getReportMethodLabelKey = (method) => {
  const slug = method?.reportMethod;

  if (!slug) {
    return null;
  }

  const source = method?.metadata?.source;

  switch (slug) {
    case 'crew_action_by_employee':
      return 'reportMethodCrewEmployee';
    case 'crew_employee_edit_timesheet':
      return 'reportMethodCrewEmployeeEditTimesheet';
    case 'kiosk_qr_scanned_by_employee':
      return 'reportMethodKioskQr';
    case 'kiosk_employee_id_entered':
      return 'reportMethodKioskId';
    case 'captain_scan_employee_qr':
      return 'reportMethodCaptainQr';
    case 'captain_manual':
      return 'reportMethodCaptainManual';
    case 'captain_set_as_schedule':
      return 'reportMethodCaptainSetAsSchedule';
    case 'system':
      return 'reportMethodSystem';
    case 'admin':
      switch (source) {
        case 'timesheet_tab':
        case 'os':
          return 'reportMethodAdminManual';
        case 'business_app':
          return 'reportMethodAdminMobileApp';
        case 'autofill':
          return 'reportMethodAdminAutofill';
        case 'job_service':
          return 'reportMethodAdminJob';
        case 'qr_scan':
          return 'reportMethodAdminQrScan';
        case 'set_as_schedule':
          return 'reportMethodAdminSetAsSchedule';
        case 'open_api':
          return 'reportMethodIntegration';
        default:
          return null;
      }
    default:
      return null;
  }
};
